export default __webpack_public_path__ + "static/media/htu-f1.31cca166.png";